<template>
    <div class="form-content" :ref="stepName" style="position:relative">
        <div class="form-header">
            <p><span>Avec la réduction de 50 % pour ma première année, j’autorise Testachats à encaisser, par le débit de mon compte bancaire, les 9,84 € par mois pendant un an au lieu de 19,68 €. À l’issue de cette période, mon abonnement sera automatiquement reconduit, et ce, jusqu’à la révocation expresse de mon affiliation. </span></p>
          <p>Après 6 mois, vous serez remboursé de vos 3 premières mensualités à 9,84€, ce qui correspond à trois mois d’abonnement gratuits.</p>
        </div>
        <PaymentOptinForm></PaymentOptinForm>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import {Button} from "../../../../../../models/fields/Button";
import PaymentOptinForm from "./PaymentOptinForm";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: {PaymentOptinForm},
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
